/** @jsx jsx */
import { jsx } from '@emotion/core';
import { TFunction, useT } from 'client/i18n/hooks/useT';
import { FieldInput } from 'components/encore/form/Field';
import { FieldValues, UseFormRegister, UseFormWatch } from 'react-hook-form';
import { Icon } from 'shared/Icon';
import {
  HorizontalFormGroup,
  IconWrapper,
  LabelWrapper,
  ProviderUrl,
  Label,
} from './styles';

type Provider = 'twitter' | 'instagram' | 'youtube' | 'facebook' | 'website';

type ReturnProviderData = {
  iconType: 'TwitterLogo' | 'Instagram' | 'Youtube' | 'FacebookLogo' | 'link';
  label: string;
  color: string;
};

export function SocialConnection({
  provider,
  register,
  watch,
}: {
  provider: Provider;
  register: UseFormRegister<FieldValues>;
  watch: UseFormWatch<FieldValues>;
}) {
  const t = useT();
  const { iconType, label, color } = getProviderData(provider, t);
  const fieldName = `${provider}SocialUsername`;
  const shouldFillIcon = watch(fieldName) !== '';
  return (
    <HorizontalFormGroup
      label={
        <LabelWrapper>
          <IconWrapper>
            <Icon
              type={iconType}
              fillColor={shouldFillIcon ? color : '#5F6369'}
            />
          </IconWrapper>
          <Label>{label}</Label>
          <ProviderUrl>{`${provider}.com/`}</ProviderUrl>
        </LabelWrapper>
      }
      labelFor={fieldName}
    >
      <FieldInput {...register(fieldName)} id={fieldName} type="text" />
    </HorizontalFormGroup>
  );
}

export function getProviderData(
  provider: Provider,
  t: TFunction
): ReturnProviderData {
  switch (provider) {
    case 'twitter':
      return {
        iconType: 'TwitterLogo',
        label: 'Twitter',
        color: '#50ABF1',
      };
    case 'instagram':
      return {
        iconType: 'Instagram',
        label: 'Instagram',
        color: '#3f729b',
      };
    case 'youtube':
      return {
        iconType: 'Youtube',
        label: 'YouTube',
        color: '#c4302b',
      };
    case 'facebook':
      return {
        iconType: 'FacebookLogo',
        label: 'Facebook',
        color: '#3b5998',
      };
    default:
      return {
        iconType: 'link',
        label: t(
          'SettingsScreen.EncoreSettingsForm.SocialConnection.WebsiteFieldLabel',
          'Website',
          'Podcast settings user website field label'
        ),
        color: '#ebebec',
      };
  }
}
